import type { Round } from '@/lib/mock-data';

/**
 * Smartlink URL mapping for specific rounds
 * Only rounds with explicitly provided Smartlink URLs will show the widget
 */
const SMARTLINK_URLS: Record<string, string> = {
  // Winter 2026 Masters of Music Round 1: Party On
  // Key format: Season_RoundNumber_Theme (theme may include "1. " prefix)
  'Winter_2026_Masters_of_Music_1_Party_On': 'https://sdz.sh/Winter_2026_1_Party_On/widgetlinks',
  'Winter_2026_Masters_of_Music_1_1_Party_On': 'https://sdz.sh/Winter_2026_1_Party_On/widgetlinks', // In case theme includes "1. "
};

/**
 * Get Smartlink URL for a round if one has been explicitly provided
 * Returns null if no Smartlink URL exists for this round
 */
export function getSmartlinkUrl(round: Round): string | null {
  if (!round.season || !round.round_number || !round.theme) {
    return null;
  }

  // Create key: Season_RoundNumber_Theme
  // Handle theme that might include "1. " prefix (e.g., "1. Party On")
  const season = round.season.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
  const roundNumber = round.round_number.toString();
  // Remove "1. " prefix if present, then normalize
  let theme = round.theme.replace(/^\d+\.\s*/, '').replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
  const key = `${season}_${roundNumber}_${theme}`;

  console.log('[Smartlinks] Checking Smartlink URL:', {
    season: round.season,
    roundNumber: round.round_number,
    theme: round.theme,
    normalizedKey: key,
    hasUrl: !!SMARTLINK_URLS[key]
  });

  return SMARTLINK_URLS[key] || null;
}
